module.exports = __webpack_public_path__ + "img/2-2.c46bc35e.png";